import environment from "./Network";
import React from "react";
import Loading from "./components/Layout/Loading";
import { graphql, QueryRenderer } from "react-relay";
import Routes from "./Routes";
import { FirebaseContext } from "./Firebase";

export default class QueryComponent extends React.Component {
  render() {
    return (
      <QueryRenderer
        environment={environment}
        variables={{
          countPending: 4,
          afterPending: "",
          countAccepted: 4,
          afterAccepted: "",
          countRejected: 4,
          afterRejected: "",
          countCancelled: 4,
          afterCancelled: "",
        }}
        query={graphql`
          query QueryComponentQuery(
            $countPending: Int!
            $afterPending: String
            $countAccepted: Int!
            $afterAccepted: String
            $countRejected: Int!
            $afterRejected: String
            $countCancelled: Int!
            $afterCancelled: String
          ) {
            user {
              ...Routes_user
                @arguments(
                  countPending: $countPending
                  afterPending: $afterPending
                  countAccepted: $countAccepted
                  afterAccepted: $afterAccepted
                  countRejected: $countRejected
                  afterRejected: $afterRejected
                  countCancelled: $countCancelled
                  afterCancelled: $afterCancelled
                )
            }
          }
        `}
        render={({ error, props }) => {
          if (props) {
            return (
              <FirebaseContext.Consumer>
                {(firebase) => (
                  <Routes {...props} user={props.user} firebase={firebase} />
                )}
              </FirebaseContext.Consumer>
            );
          } else {
            return <Loading />;
          }
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/QueryComponent.js